/* eslint-disable @typescript-eslint/no-unused-vars */
import { apiHeaders, apiUrl } from "@/utils/access.utils";
import {
  SignedAgreementRequest,
  SignedAgreementResponse,
  EligibilityResponse,
} from "@/types/api";

const requestHeaders = apiHeaders();

export const fetchEligibility = async (dealerId: string): Promise<boolean> => {
  const response = await fetch(apiUrl(dealerId, "eligibility"), {
    method: "GET",
    credentials: "include",
    headers: requestHeaders,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch eligibility: ${response.status}`);
  }

  const data: EligibilityResponse = await response.json();
  return data.eligible;
};

export const fetchAdminAccess = async (_userId: string): Promise<boolean> => {
  return true;
};

export const fetchAgreementSigned = async (
  _dealerId: string,
): Promise<boolean> => {
  const response = await fetch(apiUrl(_dealerId, "signed-agreement"), {
    method: "GET",
    credentials: "include",
    headers: apiHeaders(),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch agreement signed status: ${response.status}`,
    );
  }

  const data = await response.json();
  return data.hasSignedAgreement;
};

export const sendSignedAgreementEmail = async (
  dealerId: string,
  request: SignedAgreementRequest,
): Promise<SignedAgreementResponse> => {
  const response = await fetch(apiUrl(dealerId, "signed-agreement"), {
    method: "POST",
    credentials: "include",
    headers: apiHeaders(),
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to send signed agreement email: ${response.status}`,
    );
  }

  return response.json();
};
